import { render, staticRenderFns } from "./Huekoy.vue?vue&type=template&id=c60d9206&scoped=true&"
import script from "./Huekoy.vue?vue&type=script&lang=js&"
export * from "./Huekoy.vue?vue&type=script&lang=js&"
import style0 from "./Huekoy.vue?vue&type=style&index=0&id=c60d9206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60d9206",
  null
  
)

export default component.exports